type KycRow = { label: string; value?: string | null };

type KycDetailsCardProps = {
  title: string;
  rows: KycRow[];
};

export function KycDetailsCard({ title, rows }: KycDetailsCardProps) {
  const visible = rows.filter((row) => row.value);
  if (!visible.length) return null;

  return (
    <div className="mt-2 rounded-[9px] border border-[#C6E8DE] bg-[#F0FAF6] px-3 py-2.5 text-left">
      <p className="mb-2 text-[11px] font-semibold text-[#0D8A73]">{title}</p>
      <div className="space-y-1.5">
        {visible.map((row) => (
          <div
            key={row.label}
            className="flex items-start justify-between gap-3 text-[12px]"
          >
            <span className="shrink-0 text-[#7C8B88]">{row.label}</span>
            <span className="text-right font-medium text-[#0F1817]">
              {row.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
